import { styled, alpha } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

export const MuiCheckboxFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  color: alpha("#828282", 1),
  fontWeight: theme.typography.fontWeightLight,
}));
